import { KeyValue } from '@/main/models/common';
import {
  AddressTypeTypes,
  AddressTypeActionTypes
} from './addressTypeTypes';

export function getAddressType(): AddressTypeActionTypes {
  return {
    type: AddressTypeTypes.GET_ADDRESS_TYPE
  };
}

export function getAddressTypePublic(): AddressTypeActionTypes {
  return {
    type: AddressTypeTypes.GET_ADDRESS_TYPE_PUBLIC
  };
}

export function saveAddressType(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): AddressTypeActionTypes {
  return {
    type: AddressTypeTypes.SAVE_ADDRESS_TYPE,
    payload: { data, isError, errorMessages }
  };
}

export function saveAddressTypePublic(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): AddressTypeActionTypes {
  return {
    type: AddressTypeTypes.SAVE_ADDRESS_TYPE_PUBLIC,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerAddress(): AddressTypeActionTypes {
  return {
    type: AddressTypeTypes.RESET_REDUCER_ADDRESS_TYPE
  };
}
